export enum AppInitStatus {
	BEFORE = 'before',
	IN_PROGRESS = 'in_progress',
	DONE = 'done',
}

export interface AppInitState {
	state: AppInitStatus;
}
